// Use very specific, professional exercise illustration images
// Using direct URLs is more reliable in this environment
// Using user-provided pushup image
const pushUpImg = '/pushup.png';
// Using user-provided squat image via its copied path
const squatImg = '/squat.png';
// Using user-provided plank image
const plankImg = '/plank.png';
// Using user-provided lunge image
const lungeImg = '/lunge.png';
// Mountain Climbers has been removed
const sitUpsImg = '/situps.png';
// Updated Superman image from user
const supermanImg = '/superman.png';

// This function returns the appropriate exercise image based on the exercise name
export const getExerciseImage = (exerciseName: string): string => {
  const name = exerciseName.toLowerCase();
  
  if (name.includes('push') && name.includes('up')) return pushUpImg;
  if (name.includes('squat')) return squatImg;
  if (name.includes('plank')) return plankImg;
  if (name.includes('lunge')) return lungeImg;
  if (name.includes('sit') && name.includes('up')) return sitUpsImg;
  if (name.includes('superman')) return supermanImg;
  
  // Default image if no match is found
  return pushUpImg;
};
